const ACCOUNT_STATUS = {
  LINKED: 0, // Stripe account linked
  NO_ACCOUNT: 1, // No stripe account
  REQUIRES_INFO: 2, // Stripe requires more info
};

export default ACCOUNT_STATUS;

export const detereminePaymentAccountStatus = payment_account => {
  if ((!payment_account?.user?.accepted_terms_at && !payment_account?.group) || !payment_account?.stripe_account_id)
    return ACCOUNT_STATUS.NO_ACCOUNT;

  if (payment_account?.ready_for_payment) return ACCOUNT_STATUS.LINKED;

  // Stripe action required
  return ACCOUNT_STATUS.REQUIRES_INFO;
};
